import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_OFFICES_QUERY = queryWithFallbackKey(
    gql`
        query getOfficesListing($defaultLanguage: String!) {
            getObjectFolder(fullpath: "/Contacts/Offices", defaultLanguage: $defaultLanguage) {
                children {
                    ... on object_Office {
                        id
                        key
                        name
                        email
                        phone
                        salesAddressLine1
                        salesAddressLine2
                        salesAddressLine3
                        country {
                            ... on object_Country {
                                id
                            }
                        }
                        logo {
                            fullpath
                        }
                    }
                }
            }
        }
    `,
    'GET_OFFICES_QUERY'
);

export function getOfficesQueryVariables(localeCode: LocaleCode) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
    };
}
